import { css } from "@emotion/react";

export const container = css`
  display: flex;
  flex-direction: column;
  padding: 161px 0;
`;
export const textContainer = css`
  text-align: center;

  h1 {
    font-size: 18px;
    font-weight: 600;
    color: #212529;
    line-height: 138%;
    letter-spacing: -0.01em;
  }

  p {
    margin-top: 6px;
    font-size: 13px;
    color: #666d75;
    line-height: 138%;
  }
`;
export const buttonContainer = css`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
export const button = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13.5px 26px;
  background-color: #141719;
  border-radius: 24px;

  span {
    font-size: 15px;
    font-weight: 600;
    letter-spacing: -0.01em;
    line-height: 138%;
    color: #fff;
  }
`;
